<template>
  <el-drawer
    custom-class="el-drawer-deal el-drawer-credit "
    :visible.sync="ifshow"
    size="40%"
    v-if="ifshow"
  >
    <div slot="title">
      <dealTitle :data="getByIdFullData" :statusShow="false"></dealTitle>
    </div>
    <commonReportInfo :data="getByIdFullData">
      <div slot="other">
        <el-form-item label="举报时间：">{{getByIdFullData.createtime|fullTime}}</el-form-item>
      </div>
    </commonReportInfo>
    <!-- 处理信息 -->
    <div>
      <div class="drawer-subtitle_common">
        <span>结果信息</span>
      </div>
      <el-card class="margin_top_bottom20">
        <el-form label-width="100px">
          <el-form-item label="结果说明：">{{getByIdFullData.result}}</el-form-item>
          <!-- <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
          <el-form-item label="处理人：" v-show="loginType!=='SHOP'&&loginType!=='DEALER'">{{getByIdFullData.flowusername}}</el-form-item>
          <el-form-item label="处理时间：">{{getByIdFullData.flowtime|fullTime}}</el-form-item> -->
        </el-form>
      </el-card>
    </div>
    <!-- 积分处理信息 -->
    <div>
      <div class="drawer-subtitle_common">
        <span>积分处理信息</span>
      </div>
      <el-card class="margin_top_bottom20">
        <el-form label-width="100px">
          <el-form-item label="扣信用积分：">{{getByIdFullData.points}}分</el-form-item>
          <el-form-item label="附加处罚：">{{getByIdFullData.punish}}</el-form-item>
          <el-form-item label="扣分说明：">{{getByIdFullData.pointsexplains}}</el-form-item>
          <el-form-item label="扣分时间：">{{getByIdFullData.pointtime|fullTime}}</el-form-item>
        </el-form>
      </el-card>
    </div>
  </el-drawer>
</template>
<script>
import dealTitle from "@/views/CreditScore/common/dealMainInfo/dealTitle";
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { getLoginType } from "@/libs/until";

export default {
  data() {
    return {
      ifshow: false,
      loginType:getLoginType()
    };
  },
  computed: {
    ...mapGetters(["getByIdFullData"])
  },
  components: { commonReportInfo, dealTitle }
};
</script>
